// extracted by mini-css-extract-plugin
export default {"mask":"Mask_mask__dOTS1"};